import { Action } from '@ngrx/store';

export const SUBMIT_LOGIN_FORM = 'SUBMIT_LOGIN_FORM';

export class SubmitLoginForm implements Action {
  readonly type = SUBMIT_LOGIN_FORM;
}

export type LoginActions = SubmitLoginForm;
